import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Select, MenuItem, InputLabel, FormControl, useTheme, useMediaQuery } from '@mui/material';
import { TicketTravelReason } from '../../../domain/tickets';
import { useTravelReasons } from '../hooks';

interface Props {
  value: TicketTravelReason | null;
  onChange: (reason: TicketTravelReason) => void;
}

export const TravelReasonSelect = ({ value, onChange }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();

  const { travelReasons } = useTravelReasons();

  const handleTravelReasonChange = (event) => {
    onChange(event.target.value);
  };

  const mobileSx = { width: '100%' };
  const desktopSx = { display: 'flex', flex: 1 };

  return (
    <FormControl sx={isMobile ? mobileSx : desktopSx}>
      <InputLabel id="reason-selector-label" sx={{ color: '#6C6D70' }}>
        {t('tickets_service.inputs.visit_reason')}
      </InputLabel>
      <Select
        id="reason-selector"
        value={value ?? ''}
        label={t('tickets_service.inputs.visit_reason')}
        labelId="reason-selector-label"
        sx={{ color: '#6C6D70' }}
        onChange={handleTravelReasonChange}
      >
        {travelReasons.map((reason) => (
          <MenuItem key={reason.value} value={reason.value}>
            {reason.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
